module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "good-item"
  }, [_c('div', {
    staticClass: "good-card"
  }, [_c('div', {
    staticClass: "good-img"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.goodsDetails(_vm.msg.productId)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgUrl,
      "alt": _vm.msg.productName
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img-actions"
  }, [_c('a', {
    staticClass: "act-btn",
    on: {
      "click": function($event) {
        return _vm.goodsDetails(_vm.msg.productId)
      }
    }
  }, [_vm._v("查看详情")]), _vm._v(" "), _c('a', {
    staticClass: "act-btn primary",
    on: {
      "click": function($event) {
        return _vm.goodsDetails(_vm.msg.productId)
      }
    }
  }, [_vm._v("立即购买")])])]), _vm._v(" "), _c('div', {
    staticClass: "good-info"
  }, [_c('div', {
    staticClass: "good-price"
  }, [_c('span', {
    staticClass: "symbol"
  }, [_vm._v("￥")]), _c('span', {
    staticClass: "integer"
  }, [_vm._v(_vm._s(_vm.priceInt))]), _c('span', {
    staticClass: "decimal"
  }, [_vm._v("." + _vm._s(_vm.priceDec))])]), _vm._v(" "), _c('div', {
    staticClass: "good-title",
    domProps: {
      "innerHTML": _vm._s(_vm.msg.itemTitle)
    }
  }, [_vm._v(_vm._s(_vm.msg.itemTitle))]), _vm._v(" "), (_vm.msg.subTitle) ? _c('div', {
    staticClass: "sub-title ellipsis"
  }, [_vm._v(_vm._s(_vm.msg.subTitle))]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5508cabc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mallGoods.vue
// module id = 656
// module chunks = 0